import { render, staticRenderFns } from "./ProviderInvoicesView.vue?vue&type=template&id=15b98216&lang=pug"
import script from "./ProviderInvoicesView.vue?vue&type=script&lang=ts"
export * from "./ProviderInvoicesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b98216')) {
      api.createRecord('15b98216', component.options)
    } else {
      api.reload('15b98216', component.options)
    }
    module.hot.accept("./ProviderInvoicesView.vue?vue&type=template&id=15b98216&lang=pug", function () {
      api.rerender('15b98216', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/billing/ProviderInvoices/ProviderInvoicesView.vue"
export default component.exports